export default {
    
    find:   { method: 'get',    url: 'hour_groups' },
    create: { method: 'post',   url: 'hour_groups'},
    update: { method: 'put',    url: 'hour_groups/{id}'},
    delete: { method: 'delete', url: 'hour_groups/{id}'}
}